import Badge, { IBadgeAttrs } from './Badge';
import Group from '../models/Group';
import app from '../../common/app';

export interface IGroupAttrs extends IBadgeAttrs {
  group?: Group;
}

export default class GroupBadge<CustomAttrs extends IGroupAttrs = IGroupAttrs> extends Badge<CustomAttrs> {
  static initAttrs(attrs: IGroupAttrs): void {
    super.initAttrs(attrs);

    if (attrs.group) {
      attrs.icon = attrs.group.icon() || '';
      attrs.color = attrs.group.color() || '';
      let nameSingular = attrs.label;
      if (typeof attrs.label === 'undefined') {
        let nameSingulars = attrs.group.nameSingular();
        if (nameSingulars) {
          nameSingular = nameSingulars;
          if (JSON.parse(nameSingulars)) {
            // 将字符串映射转换为 JavaScript 对象
            const obj = JSON.parse(nameSingulars);
            // 创建 Map 对象并初始化
            const map = new Map(Object.entries(obj));
            // 获取特定键的值
            nameSingular = map.get(app.data.locale);
          }
        }
      }
      attrs.label =  nameSingular;
      attrs.type = 'group--' + attrs.group.id();

      delete attrs.group;
    }
  }
}
